export default __webpack_public_path__ + "static/media/banner-14.868414ff.jpg";